import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import HolderOutlined from '@ant-design/icons/HolderOutlined';
import RcTree, { TreeNode } from 'rc-tree';
import classNames from 'classnames';
import DirectoryTree from './DirectoryTree';
import renderSwitcherIcon from '../utils/iconUtil';
import collapseMotion from '../../_utils/motion';
import dropIndicatorRender from '../utils/dropIndicator';
import { CheckBold, RectRound } from '@tencent/adp-icons-react';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
export var TreeInner = forwardRef(function (props, ref) {
  var _classNames;
  var className = props.className,
    showIcon = props.showIcon,
    showLine = props.showLine,
    _switcherIcon = props.switcherIcon,
    blockNode = props.blockNode,
    children = props.children,
    checkable = props.checkable,
    selectable = props.selectable,
    draggable = props.draggable;
  var prefixCls = usePrefixCls('tree');
  var checkBoxCls = usePrefixCls('tree-checkbox');
  var newProps = _objectSpread(_objectSpread({}, props), {}, {
    showLine: Boolean(showLine),
    dropIndicatorRender: dropIndicatorRender
  });
  var draggableConfig = React.useMemo(function () {
    if (!draggable) {
      return false;
    }
    var mergedDraggable = {};
    switch (_typeof(draggable)) {
      case 'function':
        mergedDraggable.nodeDraggable = draggable;
        break;
      case 'object':
        mergedDraggable = _objectSpread({}, draggable);
        break;
      default:
    }
    if (mergedDraggable.icon !== false) {
      mergedDraggable.icon = mergedDraggable.icon || React.createElement(HolderOutlined, null);
    }
    return mergedDraggable;
  }, [draggable]);
  var checkBoxNode = React.createElement("span", {
    className: "".concat(checkBoxCls, "-inner ").concat(checkBoxCls, "-square")
  }, React.createElement(CheckBold, {
    size: 10
  }), React.createElement(RectRound, {
    size: 6
  }));
  return React.createElement(RcTree, _objectSpread(_objectSpread({
    itemHeight: 20,
    ref: ref
  }, newProps), {}, {
    prefixCls: prefixCls,
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _defineProperty(_classNames, "".concat(prefixCls, "-unselectable"), !selectable), _classNames), className),
    checkable: checkable ? checkBoxNode : checkable,
    selectable: selectable,
    switcherIcon: function switcherIcon(nodeProps) {
      return renderSwitcherIcon(prefixCls, _switcherIcon, showLine, nodeProps);
    },
    draggable: draggableConfig
  }), children);
});
export var Tree = Object.assign(TreeInner, {
  TreeNode: TreeNode,
  DirectoryTree: DirectoryTree,
  defaultProps: {
    checkable: false,
    selectable: true,
    showIcon: false,
    motion: _objectSpread(_objectSpread({}, collapseMotion), {}, {
      motionAppear: false
    }),
    blockNode: false
  }
});